import React from "react";
import { useDispatch, useSelector } from "react-redux";
import clx from "classnames";
import { getOrdering } from "@store/selectors/pdf";
import { changeOrderingDirection, changeOrderingKey } from "@store/actions/pdf";
import CaretDown from "@iconify/icons-ion/caret-down-outline";
import CaretUp from "@iconify/icons-ion/caret-up-outline";
import Icon from "@iconify/react";
const styles = require("./styles.scss");
const TableOrdering = (props) => {
    const ordering = useSelector(getOrdering);
    const dispatch = useDispatch();
    const isSelected = () => props.orderBy === ordering.OrderBy;
    const onIndicatorClick = () => dispatch(isSelected()
        ? changeOrderingDirection()
        : changeOrderingKey(props.orderBy));
    return (React.createElement("div", { className: clx(styles.orderIndicator), onClick: onIndicatorClick },
        React.createElement(Icon, { icon: CaretUp, className: clx(styles.indicator, {
                [styles.active]: ordering.Ascending && isSelected()
            }) }),
        React.createElement(Icon, { icon: CaretDown, className: clx(styles.indicator, {
                [styles.active]: !ordering.Ascending && isSelected()
            }) })));
};
export default TableOrdering;
